import { Map, List } from 'immutable';
import * as RepositoryState from './constants/RepositoryState';
import * as DisplayMode from './constants/DisplayMode';
import * as Language from './constants/Language';
import * as FavoriteAmounts from './constants/FavoriteAmount';
import * as BetTypes from './constants/BetType';
import { loadState, saveState } from './storage';
import { CONFIG } from './config';
import * as BetStatus from './constants/BetStatus';
import { getAccessToken } from './shared/tokenUtils';
if (localStorage.getItem('favorite_1') === null) {
    localStorage.setItem('favorite_1', FavoriteAmounts.FAVOURITE_1);
}
if (localStorage.getItem('favorite_2') === null) {
    localStorage.setItem('favorite_2', FavoriteAmounts.FAVOURITE_2);
}
if (localStorage.getItem('favorite_3') === null) {
    localStorage.setItem('favorite_3', FavoriteAmounts.FAVOURITE_3);
}
if (localStorage.getItem('favorite_4') === null) {
    localStorage.setItem('favorite_4', FavoriteAmounts.FAVOURITE_4);
}
var authenticated = false;
if (getAccessToken()) {
    authenticated = true;
}
var betSlips = loadState();
var initialLive = Map({
    sports: Map(),
    leagues: Map(),
    matches: Map(),
    scores: Map(),
    outcomes: Map(),
    rates: Map(),
    valid: true,
    state: RepositoryState.NOT_INITED,
    version: 0,
    selectedMatchId: null
});
export default function () {
    var state = {
        routing: undefined,
        coupon: Map({
            quickBet: new Map({
                bet: new Map(),
                loading: false,
                status: BetStatus.INIT,
                resolution: undefined,
                stakeTime: undefined,
                betCreateError: undefined,
                freebetErrors: undefined,
                limit: undefined
            }),
            persistedBetType: undefined,
            betSlips: Map(),
            betTypes: new List(),
            couponAmount: '',
            selectedBetType: {
                betType: BetTypes.SINGLE,
                rank: null
            },
            couponStatus: new Map({
                loading: false,
                status: BetStatus.INIT,
                delay: undefined,
                resolution: undefined,
                stakeTime: undefined,
                bets: new Map()
            })
        }),
        auth: {
            authModalToggled: false,
            signInOngoing: false,
            isAuthenticating: false,
            user: {},
            authError: null,
            freebets: [],
            rememberMe: true,
            authenticated: authenticated,
            onlineTranslation: false
        },
        recover: {
            isOngoing: false,
            forgotModalToggled: false,
            state: null,
            email: undefined,
            phone: undefined,
            errorCode: undefined,
            smsRecoverModalToggled: false,
            recoverModalToggled: false,
            smsRecoveryStatus: null,
            smsRecoveryConfirm: null,
            smsRecoveryError: null,
        },
        application: Map({
            languageId: Language.resolveLanguageId(),
            sidebarToggled: false,
            userMenuToggled: false,
            quickbetModalToggled: false,
            betSlipModalToggled: false,
            activeTab: 'live',
            live: initialLive,
            liveMatch: initialLive,
            timetable: new Map({
                sports: new Map(),
                leagues: new Map(),
                matches: new Map(),
                valid: true,
                state: RepositoryState.NOT_INITED
            }),
            results: Map({
                sports: Map(),
                leagues: Map(),
                matches: Map(),
                scores: Map()
            }),
            preMatch: Map({
                sports: Map(),
                leagues: Map(),
                matches: Map(),
                outcomes: Map(),
                rates: Map(),
                valid: true,
                fetching: false
            }),
            popularMatches: Map({
                sports: Map(),
                leagues: Map(),
                matches: Map(),
                outcomes: Map(),
                rates: Map(),
                valid: true,
                fetching: false
            }),
            menu: Map({
                leagues: Map(),
                sports: Map(),
                fetching: false,
                menuFetching: false
            }),
            linesMenu: Map({
                sports: Map(),
                menuFetching: false
            }),
            bets: {
                isLoading: false,
                data: []
            },
            bettingMode: {
                acceptIncrease: localStorage.getItem('acceptIncrease') !== null && localStorage.getItem('acceptIncrease') === 'true',
                acceptDecrease: localStorage.getItem('acceptDecrease') !== null && localStorage.getItem('acceptDecrease') === 'true',
                oneClickAmount: localStorage.getItem('oneClickAmount') !== null ? +localStorage.getItem('oneClickAmount') : 50,
                isOneClickOn: localStorage.getItem('isOneClickOn') !== null && localStorage.getItem('isOneClickOn') === 'true',
            },
            unsettledBets: {
                isLoading: false,
                detailsIsLoading: false,
                data: [],
                details: []
            },
            operations: Map({
                isLoading: false,
                data: undefined,
                error: false
            }),
            betHistory: new Map({
                loading: false
            }),
            displayMode: {
                type: DisplayMode.ALL
            },
            favoriteAmounts: new Map({
                favorite_1: +localStorage.getItem('favorite_1'),
                favorite_2: +localStorage.getItem('favorite_2'),
                favorite_3: +localStorage.getItem('favorite_3'),
                favorite_4: +localStorage.getItem('favorite_4'),
            }),
            news: {
                fetching: false,
                news: []
            },
            popularLive: [],
            client: {
                country: CONFIG.countryCode,
                ip: '127.0.0.1',
                fetched: false
            },
            darkTheme: CONFIG.darkTheme,
        }),
        withdraw: new Map({
            fetching: false,
            creating: false,
            rates: {},
            providers: [],
            withdrawal: {},
            cancelStatus: undefined,
            error: undefined,
            createWithdrawError: undefined,
        }),
        recharge: new Map({
            usdt: Map({
                fetching: null,
                usdtError: null,
                infoWallet: null,
                state: null
            }),
            expay: Map({
                fetching: null,
                refer: null,
                error: null,
                amount: null,
                createdAt: null,
                invoiceId: null,
                subToken: null,
                checkStatus: null,
                checking: false,
            }),
            bironex: Map({
                fetching: false,
                error: undefined,
                createError: undefined,
                amount: undefined,
                result: undefined,
            })
        }),
        registration: {
            registrationModalToggled: false,
            registrationSuccessModalToggled: false,
            emailActivationModalToggled: false,
            thankYouModalToggled: false,
            inProcess: false,
            error: null,
            promoCodeError: null,
            userRegistration: {},
            joinType: undefined,
            joinEmail: undefined,
            joinPhone: undefined,
            joinCountryId: undefined,
            confirmRequestId: undefined,
        },
        promo: null,
        promoCode: {
            error: undefined,
        },
    };
    if (betSlips !== undefined) {
        state.coupon = state.coupon.set('betSlips', betSlips);
        saveState({
            betSlips: betSlips
        });
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/loadInitialState.js